import { VehicleType } from 'types';

export const vehicleTypeToText = (type: VehicleType | string) => {
  switch (type) {
    case VehicleType.MopedCar:
      return 'Mopedbil L6e';
    case VehicleType.Atv:
      return 'ATV';
    case VehicleType.Utv:
      return 'UTV';
    case VehicleType.Ssv:
      return 'SSV';
    case VehicleType.ElectricScooter:
      return 'Elmopeder';
    case VehicleType.WalkingScooter:
      return 'Promenadskoter';
    case VehicleType.ChildWheels:
      return 'Barnhjulingar';
    case VehicleType.LightTruck:
      return 'Lätt lastbil';
    case VehicleType.McCar:
      return 'Mc bil L7e';
    default:
      return type;
  }
};
